import Tabs from "../../../../components/common/Tabs";
import { adminDetailsTabsData } from "../../../../config/tabsConfig";

interface DetailsTabsContainerProps {
  applicationData: any;
}

const DetailsTabsContainer = ({
  applicationData,
}: DetailsTabsContainerProps) => {
  if (!applicationData) {
    return null;
  }

  const { empFirstName, empLastName, applictnId, nuid } = applicationData;

  return (
    <div className="lg:px-40! min-h[67vh] mt-9!">
                <hr className='-variation-1 my-[70px]!' />

      <h2 className="h2 mb-5!">
        {empFirstName} {empLastName} - Application {applictnId} - Citizenship Reimbursement Fee
      </h2>
      <Tabs tabs={adminDetailsTabsData} extraProps={{ applicationData: { ...applicationData, nuid }, applicationId: applictnId }} />
    </div>
  );
};

export default DetailsTabsContainer;
